export default "__VITE_ASSET__DePVHKIJ__"